import { VibeChatStore } from "./vibe-chat-store";

export const chatStoreInstance = new VibeChatStore();
